import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appCmsElement]',
    standalone: false,
})
export class CmsElementDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
